import type { ThemeConfig } from "antd";
import { typography } from "@libertify/ui";

/**
 * Theme override for a page's filters + table block: the regular typography
 * (Inter) instead of the app's display font; every other token is inherited.
 * Wrap the block in `<ConfigProvider theme={TABLE_THEME}>`.
 */
export const TABLE_THEME: ThemeConfig = {
  token: { fontFamily: typography.fontFamily.secondary },
};
